/**
 * The public landing (`/t/:slug`) and About (`/t/:slug/about`) routes are served
 * for every tenant, but the instructor biography they carry belongs to exactly
 * one of them. Tenancy rules do not belong inline in JSX, so the decision lives
 * here as a named predicate with its own unit test — the same shape as
 * `lib/nav/tenant-nav-links`.
 *
 * This is presentation gating, not an authorisation boundary: nothing here is
 * private, and RLS still governs every tenant-scoped read behind these pages.
 */

/** The tenant whose public pages carry the instructor profile and biography. */
export const INSTRUCTOR_PROFILE_TENANT_SLUG = "astromania";

/**
 * Whether this tenant's public pages should render the instructor profile,
 * biography and philosophy sections. Every other tenant gets a neutral page
 * built from its own name and catalogue.
 *
 * The slug arrives from a route param, so it is normalised rather than trusted.
 */
export function showsInstructorProfile(tenantSlug: string | null | undefined): boolean {
  return (tenantSlug ?? "").trim().toLowerCase() === INSTRUCTOR_PROFILE_TENANT_SLUG;
}
